import React from "react";
import CompanyContacts from "components/EditCompanyContacts/CompanyContacts";
import { useLoginContext } from "@bindeleddet/core/contexts/login";
import { Typography } from "antd";

const { Title } = Typography;
const ContactPersons = () => {
  const { currentUser } = useLoginContext();
  if (!currentUser) return null;
  return (
    <>
      <Title level={2}>Mine kontaktpersoner</Title>
      <CompanyContacts companyId={currentUser.id} />
    </>
  );
};

export default ContactPersons;
